import styled from "styled-components";

export const InputTitle = styled.text`
  font-size: 0.875rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
  line-height: 1.43;
`
